export function BackgroundImage({ alt, src, height="h-[400px]" }) {
  return (
    <div className={`w-full relative p-4 ${height}`}>
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-contain"
      />
    </div>
  )
}